import { render } from "./clientInvoice.vue?vue&type=template&id=72b11a92&scoped=true"
import script from "./clientInvoice.vue?vue&type=script&lang=js"
export * from "./clientInvoice.vue?vue&type=script&lang=js"

import "./clientInvoice.vue?vue&type=style&index=0&id=72b11a92&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b11a92"]])

export default __exports__